import * as React from "react";

import {
  Container,
  StepTitle,
  StepDescription,
  StepContainer,
  StepDisclaimer,
} from "./styles";
import { messages } from "./intl";

const steps = [
  {
    title: messages.kidminStep1Title,
    description: messages.kidminStep1Description,
    disclaimer: messages.kidminStep1Disclaimer,
  },
  {
    title: messages.kidminStep2Title,
    description: messages.kidminStep2Description,
    disclaimer: messages.kidminStep2Disclaimer,
  },
];

export const KidminSteps = () => {
  return (
    <Container>
      {steps.map((step) => {
        return (
          <StepContainer>
            <StepTitle>{step.title}</StepTitle>
            <StepDescription>{step.description}</StepDescription>
            <StepDisclaimer>{step.disclaimer}</StepDisclaimer>
          </StepContainer>
        );
      })}
    </Container>
  );
};
